////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const initKioskCreationBankDetails = {
	[ActionsTypes.GET_KIOSK_CREATION_BANK_DETAILS]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				bankDetails: {
					data: {
						$set: {},
					},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_BANK_DETAILS_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				bankDetails: {
					data: {
						$set: payload.data,
					},
				},
				statusId: {
					$set: payload.data.progressInfo.statusId,
				},
				requestId: {
					$set: payload.id,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_BANK_DETAILS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.PUT_SAVE_BANK_DETAILS]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.PUT_SAVE_BANK_DETAILS_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				bankDetails: {
					data: {
						$set: payload.data,
					},
				},
				statusId: {
					$set: payload.data.progressInfo.statusId,
				},
			},
		})
	},
	[ActionsTypes.PUT_SAVE_BANK_DETAILS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.PUT_CONTINUE_BANK_DETAILS]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.PUT_CONTINUE_BANK_DETAILS_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				bankDetails: {
					data: {
						$set: payload.data,
					},
				},
				statusId: {
					$set: payload.data.progressInfo.statusId,
				},
			},
		})
	},
	[ActionsTypes.PUT_CONTINUE_BANK_DETAILS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_BANK_DETAILS]: (state, _payload) =>
		update(state, {
			initKioskCreation: {
				statusId: {
					$set: 0,
				},
				requestId: {
					$set: null,
				},
				bankDetails: {
					availableOptions: {
						$set: {},
					},
					data: {
						$set: {},
					},
					isEditable: {
						$set: true,
					},
				},
				forceReadOnly: {
					$set: false,
				},
			},
		}),
}

export default initKioskCreationBankDetails
